import BaseService from '@services/base.service';

class BannerAndPresentationService extends BaseService {
  constructor() {
    super('banner-and-presentations');
  }
}

export default new BannerAndPresentationService();
